<div class="row rateUs animate__animated rounded bounceIn animate__delay-3s" [ngStyle]="{'background': menu.colorText? menu.colorText: restaurant.color}"
  *ngIf="restaurant.form && showForm">
  <div class="col rounded" [ngStyle]="{'background': menu.colorText? menu.colorText: restaurant.color}">
    <a (click)="openForm()" class="{{menu.fontText}} rateUs-label" [ngStyle]="{'color': menu.color? menu.color: restaurant.color}">
      <i class="fa fa-star-half-alt"></i> {{ language === 'ES'? 'Califícanos':
      'Rate us'}}
    </a>
  </div>
</div>
<div class="row d-flex fadeInLeft animate__animated justify-content-center alert-rate" *ngIf="showAlert">
  <div class="co-10">
    <div class="alert alert-success" role="alert">
      <i class="fa fa-check"></i>
      {{ language === 'ES' ? 'Tu calificación fue enviada.' : 'Your rating has been submitted.'}}
    </div>
  </div>
</div>
<footer class="animate__animated fadeIn p-3 footer backgrounds"
  [ngStyle]="{'background': menu.color? menu.color: restaurant.color, 'background-image': 'url(' + menu?.background + ')'}">
  <div class="row text-center justify-content-center">
    <div class="col-6">
      <ul class="nav nav-footer justify-content-around">
        <li *ngIf="restaurant.home && isModuleMenu">
          <a (click)="goHome()" [ngStyle]="{'color': colorText}">
            <h3 class="{{menu.fontText}}" [ngStyle]="{'color': colorText}"> <i class="fas fa-home"></i>
            </h3>
          </a>
        </li>
        <li *ngIf="restaurant.instagram !== ''">
          <a [href]="link" target="_blank" [ngStyle]="{'color': colorText}" (click)="clickLink('i')">
            <h3 class="{{menu.fontText}}" [ngStyle]="{'color': colorText}"> <i class="fab fa-instagram"></i>
            </h3>
          </a>
        </li>
        <li *ngIf="restaurant.phone !== ''">
          <a [href]="linkWs" target="_blank" [ngStyle]="{'color': colorText}" (click)="clickLink('w')">
            <h3 class="{{menu.fontText}}" [ngStyle]="{'color': colorText}"> <i class="fab fa-whatsapp"></i>
            </h3>
          </a>
        </li>
        <li *ngIf="restaurant?.google && restaurant.google !== ''">
          <a [href]="restaurant.google" target="_blank" [ngStyle]="{'color': colorText}" (click)="clickLink('g')">
            <h3 class="{{menu.fontText}}" [ngStyle]="{'color': colorText}"> <i class="fab fa-google"></i>
            </h3>
          </a>
        </li>
        <li *ngIf="restaurant.trip !== '' && restaurant.trip">
          <a [href]="restaurant.trip" target="_blank" [ngStyle]="{'color': colorText}" (click)="clickLink('t')">
            <h3 class="{{menu.fontText}}" [ngStyle]="{'color': colorText}">
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" id="tripadvisor" [ngStyle]="{'fill': colorText}">
                <path
                  d="M5.95 10.085C4.312 10.083 2.983 11.387 2.98 13s1.323 2.921 2.961 2.924 2.967-1.303 2.97-2.915v-.004-.001C8.908 11.394 7.584 10.089 5.95 10.085zM7.89 13.005c-.003 1.055-.869 1.91-1.94 1.915-1.074.002-1.946-.853-1.948-1.91s.866-1.916 1.94-1.918c1.074-.002 1.946.853 1.948 1.91V13.005zM17.977 12.022c-.551 0-.998.44-.998.982 0 .542.447.982.998.982.551 0 .998-.44.998-.982C18.974 12.462 18.527 12.022 17.977 12.022z">
                </path>
                <path
                  d="M22.823,9.503c0.257-0.848,0.661-1.635,1.166-2.31L19.983,7.19l0.06,0.035c-2.256-1.408-4.933-2.224-7.802-2.224c-0.088,0-0.176,0.001-0.252,0.003C11.88,5.001,11.771,5,11.661,5C8.739,5,6.014,5.826,3.774,7.218L0.015,7.22L0,7.199C0.516,7.89,0.918,8.668,1.19,9.563c-1.964,2.626-1.394,6.322,1.274,8.256c2.593,1.88,6.23,1.408,8.24-1.068l1.277,1.883l1.29-1.899c2.045,2.569,5.818,3.02,8.427,1.007H21.7c2.565-1.979,3.058-5.613,1.11-8.185L22.823,9.503z M10.815,13.058c-0.004,2.604-2.147,4.714-4.792,4.717c-2.646,0-4.792-2.112-4.792-4.718s2.145-4.719,4.792-4.719s4.792,2.112,4.792,4.718V13.058z M12.006,12.628c-0.228-3.041-2.765-5.411-5.86-5.477c1.753-0.718,3.675-1.119,5.691-1.119c0.048,0,0.096,0.001,0.137,0.001c0.073-0.001,0.146-0.002,0.22-0.002c2.026,0,3.953,0.421,5.604,1.142C14.733,7.261,12.232,9.616,12.006,12.628L12.006,12.628z M19.649,17.506c-2.483,0.901-5.237-0.349-6.155-2.793v-0.001c-0.916-2.445,0.355-5.158,2.838-6.059c2.483-0.902,5.238,0.35,6.154,2.795h-0.001C23.402,13.892,22.131,16.605,19.649,17.506z">
                </path>
                <path
                  d="M17.977 10.085c-1.638-.001-2.966 1.306-2.967 2.918-.001 1.613 1.325 2.921 2.963 2.921 1.638.001 2.966-1.306 2.967-2.918v-.002-.001C20.938 11.394 19.613 10.088 17.977 10.085zM17.977 14.919c-1.073 0-1.945-.856-1.945-1.914 0-1.056.871-1.915 1.944-1.915 1.073 0 1.944.856 1.944 1.914C19.919 14.061 19.05 14.917 17.977 14.919zM5.946 12.022c-.551 0-.998.44-.998.982 0 .542.447.982.998.982s.998-.44.998-.982C6.944 12.462 6.497 12.022 5.946 12.022z">
                </path>
              </svg>
            </h3>
          </a>
        </li>
      </ul>
      <h6 *ngIf="address" class="{{menu.fontText}} mt-2" [ngStyle]="{'color': menu.colorText}">{{ restaurant.address }}
      </h6>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <h6 class="{{menu.fontText}} m-0" [ngStyle]="{'color': colorText}"><a href="https://eazzymenu.com/" target="_blank" rel="noopener noreferrer" [ngStyle]="{'color': colorText}"
          class="text-underline">By Eazzy</a>
      </h6>
    </div>
  </div>
</footer>